import { KeylandingConfigTypes } from "./types/keylanding-config-types";

export const KeylandingConfig: KeylandingConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
